var _circle, _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlegSen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13090_62970",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83501 0 0 7.83502 0 17.5C0 27.165 7.83501 35 17.5 35Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13090_62970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.60794 -0.296265H-9.1875V35.2888H8.60794V-0.296265Z",
    fill: "#00853F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4004 -0.295898V35.2891H8.60547V-0.295898H26.4004ZM16.1709 15.6924H11.873L15.3486 18.2236L14.0049 22.3369L17.5029 19.7939L21.002 22.3369L19.6641 18.2236L23.1396 15.6924H18.8418L17.5029 11.6025L16.1709 15.6924Z",
    fill: "#FDEF42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.19 -0.296265H26.3945V35.2888H44.19V-0.296265Z",
    fill: "#E31B23"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13090_62970",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83501 0 0 7.83502 0 17.5C0 27.165 7.83501 35 17.5 35Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13090_62970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6624 18.2241L23.1381 15.6926H18.8398L17.5017 11.6029L16.1693 15.6926H11.8711L15.3468 18.2241L14.0028 22.3369L17.5017 19.7939L21.0005 22.3369L19.6624 18.2241Z",
    fill: "#00853F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlegSen);
export default __webpack_public_path__ + "static/media/flegSEN.6612f3e7028599ed8404d895f09a367a.svg";
export { ForwardRef as ReactComponent };